// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'normalize.css';
import App from './App';
import router from './router';
import VueClipboard from 'vue-clipboard2';
import AsyncComputed from 'vue-async-computed'

Vue.use(AsyncComputed);
Vue.use(VueClipboard);

Vue.config.productionTip = false;
// Vue.config.devtools = true;
Vue.config.errorHandler = function (err, vm, info)  {
  console.log('[Global Error Handler]: Error in ' + info + ': ' + err);
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js